module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABV0lEQVQ4T63UMS8EURQF4HOWjmYqKmqJXiNLoyFsRPSKnZfsFv6ATkKrUsyd3V+AZAWhJdFotZuoaCQynUhMjkyw2cXOvpF95eTmm/vuO+8RQ1789pxzKwBOcvysNgEwDmDLzI7+qu2A1Wp1uVQqXeSA12a26Jw7BlAhuRpF0dXPem9Q0m0cx/NhGLZIVgC8pmm62Gw277rR/4CnJNcyRFJCsmxm999oYdA5t01y9gsck7Qkaa7RaDxk37xBADdmttC9vVqtFqRp+gJg3cxaRcE3AM/dTQAYATApaTWO4/OiYN8A+IDvANIBmc+6G/2aZX6HknaTJNnLA4MgqAM48AIBZIG9lNQ5tJ6skQJQBrDhCxa64QNnKOmJ5OMAdQLAlG+HO2a2nweGYVgneegLtgG082YoaZrkjC843BkW0j4fid859Hhg+/6H5GYURWc9V69oV/3qPwBwTdcVeq8IjQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dingdan/tabbar_icon_contract_nor.png
// module id = zUjY
// module chunks = 1